import React, { ReactElement, useMemo } from 'react';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import * as NavigationSelectors from '../../../../redux/reducers/gl_navigation_reducer/selectors';
import useStyles from '../styles';
import { useDispatch } from 'react-redux';
import NavigationActions from '../../../../redux/reducers/gl_navigation_reducer/actions';
import { useHistory, useLocation } from 'react-router';
import { SideBarConfig } from '../../../config/Routes';
import { Avatar, Box, Collapse, Hidden, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import * as AuthenticationSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import Configuration from '../configuration';
import * as Paths from '../../../../utils/path';
import clsx from 'clsx';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NavigationConfig from '../../../config';

const SidebarList = () => {
  // console.log('Render SidebarList');

  const classes = useStyles();
  const theme = useTheme();
  const open = NavigationSelectors.useSidebarIsVisible();
  const dispatch = useDispatch();
  const history = useHistory();
  const { username, email } = AuthenticationSelectors.useSelectUserData();

  const handleDrawerClose = () => {
    dispatch(NavigationActions.setSideMenuVisiblityAction(false));
  };

  // const SideBarData = React.memo(() => {

  // }, []);

  const Content = (
    <React.Fragment>
      <div
        style={{
          backgroundColor:
            Configuration.sidebar.config?.primaryColor || 'white',
        }}
        className={classes.drawerHeader}
      >
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === 'ltr' ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>
      <Box
        style={{
          backgroundColor:
            Configuration.sidebar.config?.primaryColor || 'white',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          borderBottom: '1px solid #393A42',
        }}
        alignItems="center"
        display="flex"
        flexDirection="column"
        p={2}
      >
        <Avatar
          className={classes.avatar}
          component={Link}
          variant="circle"
          src={Configuration.profile.config?.iconSrc || null}
          to={NavigationConfig.mainPage().path}
        />
        <div
          style={{
            textAlign: 'left',
            marginLeft: '1rem',
          }}
        >
          <Typography
            color="textPrimary"
            style={{
              marginBottom: '0',
              fontSize: '1.3rem',
              fontWeight: 'normal',
              lineHeight: '1.5rem',
              // color: Configuration.sidebar.config?.primaryTextColor,
              color: '#778192',
            }}
          >
            {username}
          </Typography>
          <Typography
            color="textSecondary"
            style={{
              fontSize: '.8rem',
              fontWeight: 'lighter',
              lineHeight: '1rem',
              // color: Configuration.sidebar.config?.primaryTextColor,
              color: '#778192',
            }}
          >
            {email}
          </Typography>
        </div>
      </Box>
      <Box
        display={'flex'}
        flexDirection="column"
        flex="1"
        style={{
          backgroundColor:
            Configuration.sidebar.config?.primaryColor || 'white',
        }}
      >
        <SidebarListContent />
      </Box>
    </React.Fragment>
  );

  const renderDrawer = () => (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={open}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      {Content}
    </Drawer>
  );

  return <React.Fragment>{renderDrawer()}</React.Fragment>;
};

interface ISubitems {
  path: string;
  title: string;
  component: React.FC;
  id: number;
  requiredRoles: Array<number>;
}

const SidebarListContent = React.memo(() => {
  // console.log('Render SidebarListContent');
  const role = AuthenticationSelectors.useSelectUserRole();
  const dispatch = useDispatch();
  const history = useHistory();

  function filterSubElements(subElements: ISubitems[]): ISubitems[] {
    return (
      subElements.filter(({ requiredRoles }) => requiredRoles.includes(role)) ||
      []
    );
  }

  // filter items by user role
  const sidebarData = useMemo(() => {
    return (
      role
        ? SideBarConfig.filter(
            ({ requiredRoles }) =>
              Array.isArray(requiredRoles) && requiredRoles.includes(role)
          )
        : []
    ).map((element) => ({
      ...element,
      subItems: Array.isArray(element.subItems)
        ? filterSubElements(element.subItems)
        : element.subItems,
    }));
  }, [role]);

  // console.log('dataaaa:', sidebarData);
  return (
    <List>
      {sidebarData.map(({ title, path, Icon, id, subItems }, index) => (
        <SidebarElement
          key={id}
          title={title}
          path={path}
          Icon={Icon}
          subItems={subItems}
          id={id}
          onClick={() =>
            path &&
            dispatch(
              NavigationActions.navigateToScreenAction(history, path, id)
            )
          }
        />
      ))}
    </List>
  );
});

interface ISubItems {
  path: string;
  title: string;
  component: React.FC;
  id: number;
}

interface ISubItemProps extends ISubItems {}

interface ISidebarElementProps {
  title: string;
  path: string | null;
  subItems?: ISubItems[];
  Icon: React.FC;
  id: number;
  onClick: () => void;
}

const SidebarSubElement = (props: ISubItemProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const currentPath = location.pathname;
  const isSelected = Paths.pathsIsTheSame(currentPath, props.path);

  return (
    <ListItem
      className={clsx(
        isSelected ? classes.drawerSelectedItem : classes.drawerUnselectedItem,
        classes.subElement
      )}
      onClick={() =>
        dispatch(
          NavigationActions.navigateToScreenAction(
            history,
            props.path,
            props.id
          )
        )
      }
      key={props.id}
    >
      {props.title}
    </ListItem>
  );
};

const SidebarElement = (props: ISidebarElementProps) => {
  // console.log("Render SidebarElement" + props.id);
  const { Icon, title, path, onClick, id, subItems } = props;
  const location = useLocation();
  const currentPath = location.pathname;
  const [expand, setExpand] = React.useState<boolean>(false);
  const classes = useStyles();
  const isSelected = subItems
    ? false
    : path && Paths.pathsIsTheSame(currentPath, path);

  const expandByPath: boolean = React.useMemo(() => {
    if (subItems) {
      for (let item of subItems) {
        if (Paths.pathsIsTheSame(currentPath, item.path)) {
          return true;
        }
      }
    }
    return false;
  }, [subItems, currentPath]);

  React.useEffect(() => {
    setExpand(expandByPath);
  }, [expandByPath]);

  return (
    <Box display="flex" flexDirection="column">
      <ListItem
        className={clsx(
          isSelected ? classes.drawerSelectedItem : classes.drawerUnselectedItem
        )}
        onClick={subItems ? () => setExpand(!expand) : onClick}
        button
        key={id}
      >
        <ListItemIcon
          style={{
            color: isSelected
              ? Configuration.sidebar.config?.listSelectedItemTextColorSelected
              : Configuration.sidebar.config?.listSelectedItemTextColor,
          }}
        >
          <Icon />
        </ListItemIcon>
        <ListItemText
          classes={{
            secondary: isSelected
              ? classes.drawerListItemTextSelected
              : classes.drawerListItemText,
          }}
          secondary={title}
        />
        {subItems && (
          <ExpandMoreIcon
            className={clsx(classes.expand, {
              [classes.expandOpen]: expand,
            })}
            aria-expanded={expand}
          />
        )}
        <Divider />
      </ListItem>
      {subItems && (
        <Collapse in={expand} timeout="auto" unmountOnExit>
          <ListSubItemsBlock subItems={subItems} />
        </Collapse>
      )}
    </Box>
  );
};

interface ISubItemsProps {
  subItems: ISubItemProps[];
}

const ListSubItemsBlock = React.memo(({ subItems }: ISubItemsProps) => {
  return (
    <List>
      {subItems.map(({ path, title, component, id }, index) => (
        <SidebarSubElement
          component={component}
          title={title}
          path={path}
          key={id}
          id={id}
        />
      ))}
    </List>
  );
});

export default SidebarList;
